<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	export let device;

	const settings = readDeviceSettings(device.id);

	let value = settings.supply_voltage;
	let cacheValue = value;

	let loading = false;

	const localIp = get_local_ip(device.id);

	const setVoltage = (val) => {
		value = val;
	};

	const sentRequest = async () => {
		if (cacheValue !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					supply_voltage: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: device.id,
					command: 'supply_voltage',
					payload: JSON.stringify({ supply_voltage: value }),
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title: $format('supply_voltage_scc_toast', {
						values: { value: value === 0 ? 110 : 230 },
						default: `Supply voltage was changed to ${value === 0 ? '110v' : '230v'}`,
					}),
				});
				settings.supply_voltage = value;
				devices_settings.update_devices_settings(device.id, settings);
				cacheValue = value;
			} else {
				value = cacheValue;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			loading = false;
		}
	};
</script>

<Radio size="m" selected={value} value={0} on:click={() => setVoltage(0)} id="radio-5c16sle">110v</Radio>
<Radio size="m" selected={value} value={1} on:click={() => setVoltage(1)} id="radio-vfyyuwu">230v</Radio>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
